import React from "react";

export function avatarUrl(user) {
  if (!user?.avatar_ext || !user?.id) return null;
  return `${process.env.REACT_APP_BACKEND_URL}/api/users/${user.id}/avatar?v=${user.avatar_v || 0}`;
}

export default function Avatar({ user, className = "", style = {} }) {
  const src = avatarUrl(user);
  const initials = (user?.name || "?").slice(0, 2).toUpperCase();

  if (src) {
    return (
      <img
        src={src}
        alt={user?.name || "Kullanıcı"}
        className={`object-cover ${className}`}
        style={style}
      />
    );
  }

  return (
    <div className={className} style={style}>
      {initials}
    </div>
  );
}
